import styled from "styled-components";
import Colors from "../../themes/Colors";

const ErrorBoundaryHolder = styled.div`
  .error-container {
    display: flex;
    align-items: left;
    justify-content: left;
    background-image: linear-gradient(100deg,${Colors.backgroundPrimary},${Colors.backgroundSecondary});
    color: ${Colors.white};

    h1 {
      font-size: 45px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 5px;
      margin-top: 25px;
      color: ${Colors.white};
    }

    p {
      font-size: 25px;
      font-weight: 500;
      text-align: left;
      margin-bottom: 25px;
      margin-top: 25px;
      line-height: 1.2;
    }
  }
  .btn-error-fallback {
    color: ${Colors.white};
    padding: 10px 20px;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
  }
  .logLatinadWhite {
    width: 300px;

    @media (max-width: 980px) {
      display: none;
    }
  }
  .imageBg {
    width: 90%;
    margin: 20px;
  }
  
  .base-btn {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    line-height: 2.5 !important;
    margin-top: 50px;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .go-back-btn {
    background-color: ${Colors.snow};
    color: ${Colors.primaryAccent};
    border-color: ${Colors.white};
  }
  .btn-error-fallback {
    background-color: ${Colors.primary};
    color: ${Colors.onPrimary};
    border-color: ${Colors.primaryAccent};
  }
  .leftSideContainer {
    margin: 25px;
    padding: 30% 30px 30px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .btns-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    gap: 8px;
  }

`;

export default ErrorBoundaryHolder;